const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
});

export default moneyFormatter;
